import { useState } from "react";
import { useBetween } from "use-between";
import { BTGlobal as GlobalBT } from "../../../utils/BTglobal/BTGlobal";
import { contStep6 } from "../form/StepContract6";
import { createContractSchemas } from "../ICreateContract";
import { get_set_ls, getLStorage, setLStorage } from "global.d";

const BTCreateContract6 = () => {
    const { btGridRef } = useBetween(GlobalBT)
    const [contractSchemas, setContractSchemas] = useState(createContractSchemas[0])
    const [dataRow6, setDataRow6] = useState<contStep6[]>([]);
    const [dataModelo6, setDataModelo6] = useState<any>();
    const addRowStructure3 = (props: any) => {
        let data = {
            cycleWeek: props.dataRow.cycleWeek,
            fatherStructure4: props.dataRow.fatherStructure4,
            idFatherStructure4: props.dataRow.idFatherStructure4,
            mainIngredients: props.dataRow.mainIngredients,
            recipe: props.dataRow.recipe,
            id: props.dataRow.id
        }
        setDataModelo6(data)
    }
    const updateRow6 = (items: any) => {
        let dRow = dataRow6.slice()
        setDataRow6([]);
        let newRow = dRow.filter((item) => {
            if (item.id === items.id) {
                item.cycleWeek = items.cycleWeek
                item.data = items
                item.fatherStructure4 = items.fatherStructure4[0].text
                item.idFatherStructure4 = items.fatherStructure4[0].value
                item.mainIngredients = items.mainIngredients[0].text
                item.recipe = items.recipe[0].text
            }
            return item
        })
        setDataRow6(newRow);
        if (btGridRef !== undefined)
            btGridRef.current.api.refreshServerSideStore({ purge: true });
    }
    const deleteRow6 = (props: any) => {
        get_set_ls("estEliminar", props.dataRow.data.id)
        
        // let estEliminar: any = getLStorage('estEliminar')
        // if (estEliminar == null) {
        //     setLStorage('estEliminar', [])
        //     estEliminar = getLStorage('estEliminar')
        //     estEliminar.push(props.dataRow.data.id + "")
        //     setLStorage('estEliminar', estEliminar)
        // } else {
        //     if (estEliminar.indexOf(props.dataRow.data.id + "") == -1) {
        //         estEliminar.push(props.dataRow.data.id + "")
        //         setLStorage('estEliminar', estEliminar)
        //     }
        // }

        let rows = dataRow6.slice();
        let newRow = rows.filter((item) => { return item.id !== props.dataRow.id });
        setDataRow6(newRow)
    }
    return {
        contractSchemas, setContractSchemas,
        dataRow6, setDataRow6, updateRow6, deleteRow6,
        dataModelo6, setDataModelo6,
        addRowStructure3
    };
};
export { BTCreateContract6 }